import { Form, Radio, RadioChangeEvent } from "antd";
import FormAddrsChild from "./FormAddrsChild";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import './index.less'

export default function FormAddrs({form, token}: any) {
  const { t } = useTranslation()
  const [mode, setMode] = useState(1);
  const tokenAddressFrom = Form.useWatch('transferAddresses', form);
  const [list, setList] = useState([])

  const options = [
    { label: t("components.manualInput"), value: 1 },
    { label: t("components.uploadFile"), value: 2 }
  ];

  const onChangeMode = ({ target: { value } }: RadioChangeEvent) => {
    // console.log('radio3 checked', value);
    setMode(value);
  }

  function tabMode(value: any = 1) {
    setMode(value);
  }

  useEffect(() => {
    if (tokenAddressFrom) {
      // console.log('tokenAddressFrom', tokenAddressFrom)
      setList(tokenAddressFrom.trim().split('\n'))
    }
  }, [tokenAddressFrom])

  return (
    <div className="form-addrs">
      <div className="form-addrs-head-wrap">
        <div className='addrs-head'>
          <div className='title'>{ t("manyToMany.recipientAddress") }</div>
          <Radio.Group options={options} onChange={onChangeMode} value={mode} optionType="button" className='option-mode' />
        </div>
      </div>
      <Form.Item
        label=""
        name={"transferAddresses"}
        rules={[{ required: true, message: t("components.enterOrUploadBatchTransferAddresses") }]}
      >
        <FormAddrsChild form={form} mode={mode} onTabMode={tabMode}/>
      </Form.Item>
      <div className="addrs-footer-info">
        <div className="el">
          <strong>{ t("manyToMany.numberOfAddresses") }</strong>
          <strong>{ list.length > 0 ? list.length : '-' }</strong>
        </div>
      </div>
    </div>
  )
}